import HelpdeskRoute from './HelpdeskRoute'

const routes = [
    new HelpdeskRoute()
]

export default routes
